"use client";

import { useRouter, useSearchParams } from "next/navigation";
import * as React from "react";

import { LoginForm } from "@/app/login/login-form";
import { GenieLampIcon } from "@/components/icons/genie-lamp-icon";
import { useSession } from "@/lib/session";
import { safeAuthDestination } from "@/lib/auth-redirect";

export function LoginPageClient() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { user, isLoading } = useSession();

  const nextPath = searchParams.get("next");
  const expired = searchParams.get("expired") === "1";
  const redirectTo = safeAuthDestination(nextPath);

  React.useEffect(() => {
    if (user) {
      router.replace("/whatsapp");
    }
  }, [router, user]);

  return (
    <main className="relative flex min-h-svh flex-col overflow-hidden bg-background text-foreground">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,oklch(0.80_0.15_84/18%),transparent_68%)]"
        data-testid="login-background-glow"
      />
      <div aria-hidden="true" className="pointer-events-none absolute top-0 left-1/2 h-px w-2/3 -translate-x-1/2 bg-linear-to-r from-transparent via-primary/55 to-transparent" />

      <header className="relative flex items-center gap-3 px-5 py-5 sm:px-8 lg:px-10">
        <span className="grid size-10 shrink-0 place-items-center rounded-lg bg-sidebar text-sidebar-foreground shadow-(--shadow-surface)">
          <GenieLampIcon className="size-7" />
        </span>
        <div>
          <p className="text-sm font-bold tracking-tight">Seu Gênio</p>
          <p className="text-2xs tracking-wide text-muted-foreground">Painel administrativo</p>
        </div>
      </header>

      <section className="relative flex flex-1 items-center justify-center px-4 py-8 sm:px-6 sm:py-10">
        <div className="w-full max-w-sm rounded-lg border bg-card p-5 shadow-(--shadow-surface) xs:p-6 sm:max-w-[30rem] sm:p-8" data-testid="login-panel">
          <div className="mb-7">
            <h1 className="text-3xl font-semibold tracking-tight">Entrar</h1>
            <p className="mt-2 text-sm leading-6 text-muted-foreground">Use suas credenciais para acessar o painel do Seu Gênio.</p>
          </div>

          <LoginForm
            initialMessage={expired ? "Sua sessão expirou. Entre novamente." : undefined}
            isSessionLoading={isLoading}
            redirectTo={redirectTo}
          />

          <p className="mt-6 border-t pt-5 text-center text-xs leading-5 text-muted-foreground">Acesso restrito a administradores cadastrados.</p>
        </div>
      </section>

      <footer className="relative px-5 py-5 text-center text-2xs tracking-wide text-muted-foreground sm:px-8">
        © 2026 Seu Gênio
      </footer>
    </main>
  );
}
